(function () {
  'use strict';

  function activateItem(playlist, item) {
    var videoId = item.getAttribute('data-video-id');
    var title = item.getAttribute('data-video-title') || '';
    if (!videoId) return;

    var iframe = playlist.querySelector('.vplaylist__iframe');
    if (iframe) {
      iframe.src =
        'https://www.youtube.com/embed/' +
        encodeURIComponent(videoId) +
        '?rel=0&autoplay=1&modestbranding=1&playsinline=1';
      iframe.title = title;
    }

    var items = playlist.querySelectorAll('.vplaylist__item');
    for (var i = 0; i < items.length; i++) {
      var isActive = items[i] === item;
      items[i].classList.toggle('is-active', isActive);
      items[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
    }

    if (typeof item.scrollIntoView === 'function') {
      item.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  }

  document.addEventListener('click', function (e) {
    var item = e.target.closest && e.target.closest('.vplaylist__item');
    if (!item) return;
    var playlist = item.closest('.vplaylist');
    if (!playlist) return;
    e.preventDefault();
    activateItem(playlist, item);
  });

  document.addEventListener('keydown', function (e) {
    var k = e.key;
    if (k !== 'ArrowDown' && k !== 'ArrowUp' && k !== 'ArrowLeft' && k !== 'ArrowRight') return;
    var active = document.activeElement;
    if (!active || !active.classList || !active.classList.contains('vplaylist__item')) return;
    var siblings = Array.prototype.slice.call(
      active.parentElement.querySelectorAll('.vplaylist__item')
    );
    var idx = siblings.indexOf(active);
    var forward = k === 'ArrowDown' || k === 'ArrowRight';
    var next = forward ? siblings[idx + 1] : siblings[idx - 1];
    if (next) {
      e.preventDefault();
      next.focus();
    }
  });
})();
